/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ReelEvent, GetReelEventName } from "./ReelEvent";
import ComponentBase from "../Utility/ComponentBase";

const ccclass = cc._decorator.ccclass;

@ccclass
export default class SymbolDimmer extends ComponentBase {

    private _reelNode: cc.Node = null;
    private _fullColor: cc.Color = cc.Color.WHITE;
    private _dimColor: cc.Color = cc.Color.GRAY;

    public set ReelNode(value: cc.Node)
    {
        this._reelNode = value;
        value.on(GetReelEventName(ReelEvent.OnEnabled), this.full, this.node);
        value.on(GetReelEventName(ReelEvent.OnDisabled), this.dim, this.node);
    }

    protected onDestroy()
    {
        this._reelNode.off(GetReelEventName(ReelEvent.OnEnabled), this.full);
        this._reelNode.off(GetReelEventName(ReelEvent.OnDisabled), this.dim);
    }

    private dim = (): void =>
    {
        for (let spine of this.getComponentsInChildren(sp.Skeleton)) {
            spine.node.color = this._dimColor;
        };
    }

    private full = (): void =>
    {
        for (let spine of this.getComponentsInChildren(sp.Skeleton)) {
            spine.node.color = this._fullColor;
        };
    }
}
